import { createWebHistory, createRouter } from "vue-router";
import Register from '@/views/Register'
import Login from '@/views/Login'

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
